import * as React from "react";
import type { SVGProps } from "react";
const SvgInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path d="M12 4.06a7.94 7.94 0 1 0 0 15.88 7.94 7.94 0 0 0 0-15.88M3.06 12a8.94 8.94 0 1 1 17.88 0 8.94 8.94 0 0 1-17.88 0m8.91-1.7a.76.76 0 0 1 .75.75v4a.75.75 0 1 1-1.5 0v-4a.75.75 0 0 1 .75-.75m-.7-1.72a.74.74 0 1 1 1.48 0 .74.74 0 0 1-1.48 0" />
  </svg>
);
export default SvgInfo;
